import { useNavigate } from 'react-router-dom'
import { useParams } from "react-router"
import { getId, getToken, usePermissions } from "../../user/User"
import { toast } from "react-toastify"
import { useEffect } from "react"
import axios from 'axios'

const AutomaticMailingDelete = () => {
    const navigate = useNavigate()

    let { id } = useParams()

    const { permissions } = usePermissions(getId())
    useEffect(() => {
        if(permissions.client === undefined) {
            return
        }
        if(!permissions.client) {
            toast.error("You don't have permission to delete automatic mailings!")
            navigate("/")
        } else {
            if (confirm('Do you really want to delete this automatic mailing?')) {
                axios.delete(process.env.REACT_APP_API_URL + "/api/automaticmailings/" + id, { headers: {
                    "Authorization": "Bearer " + getToken()
                }}).then(_ => {
                    toast.success("Deleted automatic mailing #" + id + ".")
                    navigate("/automaticmailing")
                }).catch(error => {
                    if (error.response) {
                        var statusCode = error.response.status
                        if(statusCode === 400) {
                            navigate("/automaticmailing")
                            toast.error("Invalid request.")
                            return
                        } else if(statusCode === 404) {
                            navigate("/automaticmailing")
                            toast.error("Unable to find automatic mailing #" + id + ".")
                            return
                        }
                    }
                    navigate("/automaticmailing")
                    toast.error("Internal error.")
                })
            } else {
                navigate("/automaticmailing")
            }
        }
    }, [permissions])

    return (
        <>
            <p>Deleting automatic mailing...</p>
        </>
    )
}

export default AutomaticMailingDelete